import { render, staticRenderFns } from "./InitialPerspectiveBtn.vue?vue&type=template&id=6a42e5a7&scoped=true&"
import script from "./InitialPerspectiveBtn.vue?vue&type=script&lang=ts&"
export * from "./InitialPerspectiveBtn.vue?vue&type=script&lang=ts&"
import style0 from "./InitialPerspectiveBtn.vue?vue&type=style&index=0&id=6a42e5a7&prod&scoped=true&lang=css&"
import style1 from "./InitialPerspectiveBtn.vue?vue&type=style&index=1&id=6a42e5a7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42e5a7",
  null
  
)

export default component.exports